// lazyload
jQuery(function($) {

  $('#js-loading').imagesLoaded(function(){
    $('#js-loading').find('.s-loading__container').addClass('is-ready');
    // bodyの画像数を取得
    var imgNum = imagesLoaded('body').images.length;
    // 読み込んだ画像の数を格納
    var loadedImg = 0;
    // 現在のプログレス値を格納
    var progressNowPosition = 0;
    // 1秒間に50回、progressMonitor()を実行する
    Timer = setInterval(progressMonitor, 1000 / 50);
    // ローディング解除関数
    function clearLoadWindow() {
      clearInterval(Timer);
      $('#js-loading').addClass('is-hidden');
      $('#js-body').addClass('is-show');
    }
    // 画像を読み込んだらloadedImgを加算する
    imagesLoaded('body').on('progress', function() {
      loadedImg++;
    });

    // top video
    var _mql = window.matchMedia('screen and (max-width: 767px)');
    var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
    var $video = document.getElementById('js-home-kv');
    var _videoSrc;
    var _videoPcSrc;
    if ($video != null) {
      // ▼本番用
      //https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/
      _videoSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video.mp4?d=20200108';
      _videoPcSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video-pc.mp4?d=20200108';
      // _videoSrc = './assets/image/kv/video.mp4';
      // _videoPcSrc = './assets/image/kv/video-pc.mp4';
      // console.log('あるしんど');
    } else {
      // console.log('あれ');
    }

    // 画像の読み込み状況をチェックし、更新する関数
    function progressMonitor() {
      // 読み込んだ画像のパーセンテージ
      var progressPosition = (loadedImg / imgNum) * 100;
      // プログレス値を現在値と目標値からイージングする
      progressNowPosition += (progressPosition - progressNowPosition) * 0.1;
      // プログレスバーの横幅を指定する
      $('#js-progress').css('height', progressNowPosition + '%');

      // 読み込んだ画像のパーセンテージ数値を表示する
      // $('#progressTxt').text(Math.floor(progressNowPosition) + '%');

      // 読み込みが完了した場合の処理
      if (progressNowPosition >= 100) {
        if (!$('#mw_wp_form_mw-wp-form-72').length) {
          clearLoadWindow();
          if ($video != null) {
            _mql.addListener(routingByBreakpoint);
            routingByBreakpoint(_mql);
          }
          console.log('form de ha nai');
        } else {
          // mw wp form フォームの処理
          console.log('form');
          var $formSection = $('#form-section');
          // var $formReadyFlag = false;
          // タグ整形 ラジオボタン
          $formSection.find('.mwform-radio-field').children('label').addClass('p-radiobtn');
          var newRadioBtn = $formSection.find('.p-radiobtn');
          newRadioBtn.children('.mwform-radio-field-text').removeClass().wrap('<div class="p-radiobtn__cont"><p class="p-radiobtn__txt"></p></div>');
          newRadioBtn.unwrap();
          // タグ整形 チェックボックス
          $formSection.find('.mwform-checkbox-field').children('label').addClass('p-checkbox');
          var newCheckBox = $formSection.find('.p-checkbox');
          newCheckBox.children('.mwform-checkbox-field-text').removeClass().wrap('<div class="p-checkbox__cont"><p class="p-checkbox__txt"></p></div>');
          newCheckBox.unwrap().wrap('<li></li>');
          // 送信ボタン
          $formSection.find('.p-btn__btn').val('');
          // 入力エラー処理
          if ($formSection.find('.error').length) {
            var _position = $formSection.offset().top - 80;
            var $globalErrorElm = '<div class="s-global-error"><p class="s-global-error__txt">ご入力内容に誤りがあります。<br>恐れ入りますがもう一度ご確認ください。</p></div>';
            // エラーメッセージを編集
            $formSection.find('.p-form').before($globalErrorElm);
            $formSection.find('.error').removeClass().wrap('<p class="p-form__error"></p>');
            // $formReadyFlag = true;
            clearLoadWindow();
          	$('body, html').delay(200).animate({scrollTop:_position}, 600, 'swing');
          } else {
            // $formReadyFlag = true;
            clearLoadWindow();
          }
        }
      }

      // イージング計算を完了させる
      if (progressNowPosition > 99.9) {
        progressNowPosition = 100;
      }

    }

    // ▼動画関数
    function routingByBreakpoint(_mql) {
      if (_mql.matches) {
        $video.src = _videoSrc;
        $video.load();
        $video.play();
        // console.log('spサイズだお');
      } else {
        $video.src = _videoPcSrc;
        $video.load();
        $video.play();
        // console.log('pcサイズだお');
      }
    }

  });
});
